@switch (question?.questionSubType) { 
  @case (questionSubType.RANKING) {
    <div class="rank-order-container" [class.mobile-view]="viewMode === 'mobile'">
      
      <div class="rank-order-list"> 
        @for (item of rankedItems; track item.optionId; let i = $index) {
          <div 
            class="rank-order-item"
            [class.mobile-view]="viewMode === 'mobile'"
            [class.dragging]="draggedIndex === i"
            [class.drag-over]="draggedIndex !== i"
            draggable="true"
            (click)="$event.stopPropagation()"
            (dragstart)="onDragStart($event, item, i)"
            (dragover)="onDragOver($event)"
            (dragenter)="onDragEnter($event, i)"
            (drop)="onDrop($event, i)"
            (dragend)="onDragEnd($event)">
            
            <div class="rank-order-item-content">
              <!-- <div class="rank-order-item-rank" [class]="getRankClass(item.currentRank)">
                <span class="rank-icon">{{ getRankIcon(item.currentRank) }}</span>
                <span class="rank-number">{{ item.currentRank }}</span>
              </div> -->
               <!-- <div class="rank-order-item-rank" >
                <span class="rank-number">{{ item.currentRank }}</span>
              </div>
               -->
              <div class="rank-order-item-text">
                <span class="item-label">{{ item.text | titlecase }}</span>
              </div>
              
              <div class="rank-order-item-controls">
                <button 
                  class="control-btn up-btn"
                  [disabled]="i === 0"
                  (click)="moveItemUp(i)"
                  title="Move up">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="18,15 12,9 6,15"></polyline>
                  </svg>
                </button>
                
                <button 
                  class="control-btn down-btn"
                  [disabled]="i === rankedItems.length - 1"
                  (click)="moveItemDown(i)"
                  title="Move down">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6,9 12,15 18,9"></polyline>
                  </svg>
                </button>
                
                <div class="drag-handle" title="Drag to reorder">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      
    </div>
  } 
  @default {
    <div class="unsupported-type">
      <p>Unsupported question type for ranking</p>
    </div>
  } 
}
